import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const stats = [
  { k: "48", l: "Contiguous States Served" },
  { k: "100%", l: "Federally Insured Loads" },
  { k: "<60min", l: "Average Quote Response" },
  { k: "1:1", l: "Direct Coordinator Relationship" },
];

const About = () => {
  return (
    <div data-testid="about-page" className="bg-[#050914] text-white">
      <section className="pt-40 pb-20 md:pt-48 md:pb-28 border-b border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7">
            <div className="text-[11px] uppercase tracking-[0.3em] text-slate-400 mb-6">About Ferrer</div>
            <h1 className="font-display font-bold text-5xl md:text-6xl lg:text-7xl leading-[0.95] mb-8">
              Family-built.
              <br />
              <span className="text-silver">Nationally trusted.</span>
            </h1>
            <p className="text-lg md:text-xl text-slate-300 max-w-2xl leading-relaxed">
              Ferrer Auto Transport was built on a simple promise — treat every customer's
              vehicle like it belongs to family. Out of Woodbridge, New Jersey, we've quietly
              become the team dealers, snowbirds, exotic owners, and everyday drivers call when
              they want it done right the first time.
            </p>
          </div>
          <div className="lg:col-span-5">
            <div className="aspect-[4/5] overflow-hidden border border-white/10">
              <img
                src="https://images.pexels.com/photos/19829080/pexels-photo-19829080.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=720"
                alt="Luxury vehicle in motion"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 md:py-32 border-b border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
            {stats.map((s, i) => (
              <div key={i} data-testid={`about-stat-${i}`} className="bg-[#050914] p-8 md:p-12">
                <div className="font-display font-bold text-4xl md:text-5xl text-white mb-3">{s.k}</div>
                <div className="text-xs uppercase tracking-[0.25em] text-slate-400">{s.l}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 md:py-32 border-b border-white/10">
        <div className="max-w-[1100px] mx-auto px-6 md:px-12">
          <div className="text-[11px] uppercase tracking-[0.3em] text-slate-400 mb-6">Our Mission</div>
          <h2 className="font-display font-semibold text-4xl md:text-5xl lg:text-6xl mb-10 leading-tight">
            Make auto transport feel <span className="text-silver">premium</span> — at every price point.
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 text-slate-300 leading-relaxed">
            <p>
              Auto transport has long been an industry full of disappearing brokers, vague pricing,
              and missed pickups. We started Ferrer to be the opposite of all that — a transparent,
              accountable, family-operated team that treats every shipment with the seriousness it
              deserves.
            </p>
            <p>
              Whether you're shipping a daily-driver sedan from New Jersey to Florida or moving a
              fleet of luxury vehicles across the country, you'll work directly with a coordinator
              who answers the phone, hits the schedule, and stays on it until the keys are back in
              your hand.
            </p>
          </div>
        </div>
      </section>

      <section className="py-24 md:py-32">
        <div className="max-w-[1100px] mx-auto px-6 md:px-12 text-center">
          <h2 className="font-display font-semibold text-3xl md:text-5xl mb-8">
            Ready to ship your vehicle?
          </h2>
          <Link
            to="/#quote"
            data-testid="about-cta-quote"
            className="group inline-flex items-center gap-3 bg-white text-[#050914] px-8 py-5 text-[12px] uppercase tracking-[0.25em] font-semibold hover:bg-slate-200"
          >
            Get Free Quote
            <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default About;
